<template>
  <div class="row">
    <div class="col-6 pa-2">
      <v-card-title class="text-left title-margin">{{ $t('dashboard.period') }}</v-card-title>
      <div class="row">
        <dateField id="ExpirationDate" name="ExpirationDate" v-model="selectedDateRange"
          :min-date="new Date('2000-01-01')" :max-date="new Date()" :model-value="selectedDateRange" range-enabled
          @update:model-value="handleDateRangeChange" @input="DateRangeChange" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-3 pa-2">
      <v-card class="card-height">
        <v-card-title class="title-margin">{{ $t('dashboard.poBysupplier') }}</v-card-title>
        <div v-if="!loader">
          <div v-if="topSuppliersSorted.length > 0" class="scrollable" ref="purchase-order-list">
            <div v-for="(supplier, index) in topSuppliersSorted" :key="index">
              <div class="d-flex align-center justify-space-between">
                <v-card-title class="title-md">{{ supplier.brandName }}</v-card-title>
                <v-card-title class="title-md">{{ supplier.consumption.toFixed(1) }} {{ supplier.devise
                  }}</v-card-title>
              </div>
              <div class="progress-container">
                <v-progress-linear v-model="progressValueSupplier[index]" color="#4F46E5" height="5"
                  rounded></v-progress-linear>
              </div>
            </div>
          </div>
          <div v-else class="content-container" style="overflow: hidden;">
            <div v-if="showWarning" class="warning-text">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#4F46E5" viewBox="0 0 24 24">
                <path
                  d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 18h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z" />
              </svg>
              <v-card-title class="textCenterWarning" :class="[$i18n.locale === 'en' ? 'title-md' : 'title-md']">
                {{ $t('dashboard.FilterDataMessage') }}
              </v-card-title>
            </div>
          </div>
        </div>
        <div v-else style="height: 250px; line-height: 250px; margin-top: 50px;">
          <v-progress-circular indeterminate size="50"></v-progress-circular>
        </div>
        <v-divider :style="{ height: `${calculateMaxHeight()}px` }" class="divider"></v-divider>
      </v-card>
    </div>
    <div class="col-3 pa-2">
      <v-card class="card-height">
        <v-card-title class="title-margin">{{ $t('dashboard.invoicebysupplier') }}</v-card-title>
        <div v-if="!loader">
          <div class="scrollable" v-if="topSuppliersByInvoicesSorted.length > 0" ref="invoices-list">
            <div v-for="(supplier, index) in topSuppliersByInvoicesSorted" :key="index">
              <div class="d-flex align-center justify-space-between">
                <v-card-title class="title-md">{{ supplier.brandName }}</v-card-title>
                <v-card-title class="title-md">{{ supplier.amountTTC.toFixed(1) }} {{ supplier.devise }}</v-card-title>
              </div>
              <div class="progress-container">
                <v-progress-linear v-model="progressValueInvoice[index]" color="#4F46E5" height="5"
                  rounded></v-progress-linear>
              </div>
            </div>
          </div>
          <div v-else class="content-container" style="overflow: hidden;">
            <div v-if="showWarning" class="warning-text">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#4F46E5" viewBox="0 0 24 24">
                <path
                  d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 18h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z" />
              </svg>
              <v-card-title class="textCenterWarning" :class="[$i18n.locale === 'en' ? 'title-md' : 'title-md']">
                {{ $t('dashboard.FilterDataMessage') }}
              </v-card-title>
            </div>
          </div>
        </div>
        <div v-else style="height: 250px; line-height: 250px; margin-top: 50px;">
          <v-progress-circular indeterminate size="50"></v-progress-circular>
        </div>
        <v-divider :style="{ height: `${calculateMaxHeight()}px` }" color="#ECECEC" class="divider"></v-divider>
      </v-card>
    </div>
    <div class="col-3 pa-2">
      <v-card class="card-height">
        <v-card-title class="title-margin">
          {{ $t('dashboard.invoicebystatus') }}
        </v-card-title>
        <v-card-title class="mt-n8 total-mrgine">
          {{ invoiceSummary.totalInvoices }}
        </v-card-title>
        <v-divider :style="{ height: `${calculateMaxHeight()}px` }" color="#ECECEC" class="divider mt-4"></v-divider>
        <div v-if="loader" class="d-flex align-center justify-center" style="height: 250px;">
          <v-progress-circular indeterminate size="50"></v-progress-circular>
        </div>
        <div :style="{ display: loader? 'none' : 'block'}" class="content-container">
          <div v-if="showWarning" class="warning-text" style="margin-top:50px !important;">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#4F46E5" viewBox="0 0 24 24">
              <path
                d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 18h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z" />
            </svg>
            <v-card-title class="textCenterWarning" :class="[$i18n.locale === 'en' ? 'title-md' : 'title-md']">{{
        $t('dashboard.FilterDataMessage') }}</v-card-title>
          </div>
          <div :style="{ display: showWarning? 'none' : 'block'}" class="flex-grow-1 d-flex align-center justify-center">
            <canvas id="pie-chart-invoice" class="chart-container progress-container"></canvas>
          </div>
        </div>
        <v-divider :style="{ height: `${calculateMaxHeight()}px` }" color="#ECECEC" class="divider"></v-divider>
      </v-card>
    </div>
    <div class="col-3 pa-2">
      <v-card class="card-height">
        <v-card-title class="title-margin">
          {{ $t('dashboard.poBystatus') }}
        </v-card-title>
        <v-card-title class="mt-n8 total-mrgine">
          {{ purchaseOrderSummary.totalPurchaseOrders }}
        </v-card-title>
        <v-divider :style="{ height: `${calculateMaxHeight()}px` }" color="#ECECEC" class="divider mt-4"></v-divider>
        <div v-if="loader" class="d-flex align-center justify-center" style="height: 250px;">
          <v-progress-circular indeterminate size="50"></v-progress-circular>
        </div>
        <div :style="{ display: loader? 'none' : 'block'}" class="content-container">
          <div v-if="showWarning" class="warning-text" style="margin-top:50px !important;">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#4F46E5" viewBox="0 0 24 24">
              <path
                d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 18h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z" />
            </svg>
            <v-card-title class="textCenterWarning" :class="[$i18n.locale === 'en' ? 'title-md' : 'title-md']">{{
        $t('dashboard.FilterDataMessage') }}</v-card-title>
          </div>
          <div :style="{ display: showWarning ? 'none' : 'block' }"
            class="flex-grow-1 d-flex align-center justify-center">
            <canvas id="doughnut-chart-purchase-order" class="chart-container progress-container"></canvas>
          </div>
        </div>
        <v-divider :style="{ height: `${calculateMaxHeight()}px` }" color="#ECECEC" class="divider"></v-divider>
      </v-card>
    </div>
    <div class="row">
      <div class="col-6 pa-2">
        <div class="row">
          <v-card-title class="text-left title-margin">{{ $t('purchaseOrder.supplier') }}</v-card-title>
        </div>
        <div class="row">
          <v-autocomplete id="Supplier" name="Supplier" class="pl-2" variant="outlined" v-model="IdSupplier"
            v-model:search="SupplierSearch" persistent-placeholder
            :placeholder="$t('placeholder.select', { itm: $t('purchaseOrder.supplier') })" :items="SupplierList"
            item-title="brandName" item-value="id" hide-details @update:modelValue="handleSelection">
            <template v-slot:item="{ props, item, index }">
              <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName">
                {{ item.brandName }}
              </v-list-item>
            </template>
          </v-autocomplete>
        </div>
      </div>
      <div class="col-6 pa-2">
        <v-card-title class="text-left title-margin ">{{ $t('dashboard.period') }}</v-card-title>
        <div class="row ">
          <dateField id="ExpirationDatereport" name="ExpirationDatereport" v-model="selectedDateRangeReport"
            :min-date="new Date('2000-01-01')" :max-date="new Date()" :model-value="selectedDateRangeReport"
            range-enabled @update:model-value="SecondDateRangeChange" />
        </div>
      </div>
    </div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="9" class="pa-2">
          <v-card>
            <v-card-title class="title-margin">{{ $t('dashboard.PaymentReport') }}</v-card-title>
            <v-card-subtitle class="text-left">{{ $t('dashboard.PaidInvoicesupplier') }}</v-card-subtitle>
            <div v-if="loadertwo" class="d-flex align-center justify-center" style="height: 250px; margin-top: 250px; ">
              <v-progress-circular indeterminate size="50" style="margin-top: -40%;"></v-progress-circular>
            </div>
            <div :style="{ height: `${calculateMaxHeightChartline()}px`, display: loadertwo ? 'none' : 'block' }"
              ref="contentContainer">
              <v-divider color="#ECECEC" class="divider"></v-divider>
              <canvas :style="{ display: showWarningtwo ? 'none' : 'block' }" ref="lineChartCanvas" id="lineChartCanvasid"
                :chart-data="lineChartData" :options="lineChartOptions"></canvas>
              <div v-if="showWarningtwo" class="warning-text d-flex flex-column align-center justify-center"
                ref="warningInfo" style="margin-top:20% !important;">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#4F46E5" viewBox="0 0 24 24">
                  <path
                    d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 18h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z" />
                </svg>
                <v-card-title class="textCenterWarning" :class="[$i18n.locale === 'en' ? 'title-md' : 'title-md']">{{
        $t('dashboard.FilterDataMessage')
      }}</v-card-title>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" class="pa-2">
          <v-card>
            <v-card-title class="title-margin">{{ $t('dashboard.PObythreshold') }}</v-card-title>
            <v-divider :style="{ height: `${calculateMaxHeight()}px` }" color="#ECECEC" class="divider"></v-divider>
            <div v-if="loadertwo" class="d-flex align-center justify-center" style="height: 250px;">
              <v-progress-circular indeterminate size="50"></v-progress-circular>
            </div>
            <div v-else>
              <v-card-subtitle class="text-left">{{ $t('dashboard.lessthan80%') }}</v-card-subtitle>
              <div v-for="(item, index) in itemsUnder80Percent" :key="index" class="align-center d-flex mt-1 ml-5">
                <span class="green-text">{{ item.under80PercentCount }}</span>
                <span class="ml-1 green-text" style="margin-left:160px !important;">
                  <v-icon class="ml-1 mt-n1">mdi-menu-up</v-icon>
                  {{ item.under80PercentPercentage }}%
                </span>
              </div>
              <v-divider></v-divider>
              <v-card-subtitle class="text-left">{{ $t('dashboard.morethan80%') }}</v-card-subtitle>
              <v-divider></v-divider>
              <div v-for="(item, index) in itemsOver80Percent" :key="index" class="align-center d-flex mt-1 ml-5">
                <span class="red-text">{{ item.over80PercentCount }}</span>
                <span class="ml-1 red-text" style="margin-left:160px !important;">
                  <v-icon class="ml-1 mt-n1">mdi-menu-down</v-icon>
                  {{ item.over80PercentPercentage }}%
                </span>
              </div>
              <v-divider class="divider"></v-divider>
            </div>
          </v-card>
          <v-card class="custom-margin">
            <v-card-title class="title-margin">{{ $t('dashboard.Byduedate') }}</v-card-title>
            <v-divider :style="{ height: `${calculateMaxHeight()}px` }" color="#ECECEC" class="divider"></v-divider>
            <div v-if="loadertwo" class="d-flex align-center justify-center" style="height: 250px;">
              <v-progress-circular indeterminate size="50"></v-progress-circular>
            </div>
            <div v-else>
              <v-card-text class="d-flex align-center">
                <span class="text title-md mt-n8">{{ $t('dashboard.POExpired') }}</span>
                <span class="red-text mt-n8 mr-1 ml-2">{{ totalExpiredPurchaseOrders }}</span>
                <div class="mt-n8 ml-1">
                  <span class="red-text" style="margin-left:75px">
                    <v-icon class="ml-1 mt-n1">mdi-menu-down</v-icon>
                    {{ PoPercentageOfTotal }}%
                  </span>
                </div>
              </v-card-text>
              <v-card-text class="d-flex align-center">
                <span class="text title-md mt-n8">{{ $t('dashboard.SoonExpired') }}</span>
                <span class="orange-text mt-n8 mr-1 ml-2">{{ TotalExpiringSoonPurchaseOrders }}</span>
                <div class="mt-n8 ml-1">
                  <span class="orange-text" style="margin-left:75px;">
                    <v-icon class="ml-1 mt-n1">mdi-menu-down</v-icon>
                    {{ PoPercentageExpiringSoon }}%
                  </span>
                </div>
              </v-card-text>
              <v-divider :style="{ height: `${calculateMaxHeight()}px` }" color="#ECECEC" class="divider"></v-divider>
              <v-card-text class="d-flex align-center">
                <span class="text title-md mt-n8">{{ $t('dashboard.InvoicesExpired') }}</span>
                <span class="red-text mt-n8 mr-1 ml-2">{{ totalExpiredInvoices }}</span>
                <div class="mt-n8">
                  <span class="red-text" style="margin-left:55px">
                    <v-icon class="ml-1 mt-n1">mdi-menu-down</v-icon>
                    {{ InvoicePercentageOfTotal }}%
                  </span>
                </div>
              </v-card-text>
              <v-card-text class="d-flex align-center">
                <span class="text title-md mt-n8">{{ $t('dashboard.SoonExpired') }}</span>
                <span class="orange-text mt-n8 mr-2 ml-2">{{ totalExpiringSoonInvoices }}</span>
                <div class="mt-n8 ml-1">
                  <span class="orange-text" style="margin-left:70px;">
                    <v-icon class="ml-1 mt-n1">mdi-menu-down</v-icon>
                    {{ InvoicePercentageExpiringSoon }}%
                  </span>
                </div>
              </v-card-text>
              <v-divider :style="{ height: `${calculateMaxHeight()}px` }" class="divider"></v-divider>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title class="title-margin">{{ $t('dashboard.Spendbypurchaseorder') }}</v-card-title>
            <v-card-subtitle class="text-left">{{ $t('dashboard.Paidpurchaseorder') }}</v-card-subtitle>
            <v-divider :style="{ height: `${calculateMaxHeight() }px` }" color="#ECECEC" class="divider"></v-divider>
            <v-card-text>
              <canvas ref="verticalChartCanvas" id="vertical-bar-chart" width="600" height="400"></canvas>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>

import Chart from 'chart.js/auto';
import { GetCompletedPurchaseOrdersbySuppliers, GetExpiredPurchaseOrders, GetExpiredInvoices, GetInvoiceSummary, GetPurchaseOrderSummary, GetTopSuppliers, GetTopSuppliersByInvoices, GetPurchaseOrderByThresold, GetCompanyFromPurchaseOrders, GetPaidInvoicesAmountByCurrency } from "@/api/index";
import dateField from "@/genericComponent/date-field.vue";
import * as moment from 'moment';
import ChartDataLabels from 'chartjs-plugin-datalabels';


export default {
  components: {
    dateField,
  },
  data() {
    return {
      totalExpiredPurchaseOrders: 0,
      TotalExpiringSoonPurchaseOrders: 0,
      totalExpiringSoonInvoices: 0,
      totalExpiredInvoices: 0,
      InvoicePercentageOfTotal: null,
      InvoicePercentageExpiringSoon: null,
      PoPercentageOfTotal: null,
      PoPercentageExpiringSoon: null,
      CompletedPurchaseOrders: [],
      loader: true,
      loadertwo: true,
      selectedDateRange: [],
      selectedDateRangeReport: [],
      purchaseOrderChart: null,
      CompletedPurchaseOrdersChart: null,
      paidInvoices: null,
      invoiceChart: null,
      topSuppliersFiltered: [],
      showAll: false,
      IdSupplier: null,
      brandName: null,
      SupplierSearch: null,
      dates: null,
      startDate: null,
      endDate: null,
      startDatereport: null,
      endDatereport: null,
      SupplierList: [],
      itemsUnder80Percent: [],
      itemsOver80Percent: [],
      topSuppliers: [],
      topSuppliersByInvoice: [],
      progressValueSupplier: [],
      progressValueInvoice: [],
      purchaseOrderList: null,
      invoicesList: null,
      lineChartCtx: null,
      showWarning: false,
      showWarningtwo: false,
      sortedSuppliers: null,
      lineChartData: null,
      lineChartOptions: null,
      summary: null,
      invoicesdataEntries: null,
      POdataEntries: null,
      purchaseOrderSummary: {
        totalPurchaseOrders: 0,
        validatedByClient: { count: 0, percentage: 0 },
        validatedBySupplier: { count: 0, percentage: 0 },
        refusedBySupplier: { count: 0, percentage: 0 },
        completed: { count: 0, percentage: 0 },
      },
      invoiceSummary: {
        totalInvoices: 0,
        paidInvoices: { count: 0, percentage: 0 },
        sentInvoices: { count: 0, percentage: 0 },
        rejectedInvoices: { count: 0, percentage: 0 },
        validatedInvoices: { count: 0, percentage: 0 },
      },

    };
  },
  created() {
    this.GetSupplierList();
  },
  computed: {
    showViewAllButton() {
      return this.topSuppliersSorted && this.topSuppliersSorted.length > 0;
    },
    showViewAllButtonInvoice() {
      return this.topSuppliersByInvoicesSorted && this.topSuppliersByInvoicesSorted.length > 0;
    },
    displayedSuppliers() {
      if (this.showAll) {
        return this.topSuppliersSorted;
      } else {
        return this.topSuppliersSorted.slice(0, 4);
      }
    },
    topSuppliersSorted() {
      return [...this.topSuppliers].sort((a, b) => b.consumption - a.consumption);
    },
    topSuppliersByInvoicesSorted() {
      return [...this.topSuppliersByInvoice].sort((a, b) => b.amountTTC - a.amountTTC);
    },

  },

  mounted() {
    document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.myDashboard');

    this.updatePieChartPurchaseOrder();
    this.updateInvoicePieChart();
    this.fetchPurchaseOrderSummary();
    this.fetchInvoiceSummary();
    this.fetchTopSuppliersByPo();
    this.fetchTopSuppliersByInvoices();
    this.fetchThresholdData();
    this.fetchPaidInvoicesAmountByCurrencyData();
    this.fetchExpiredPurchaseOrdersData();
    this.fetchExpiredInvoicesData();
    this.fetchCompletedPurchaseOrdersbySuppliersData();
  },
  methods: {
    async handleDateRangeChange(dates) {
      if (Array.isArray(dates) && dates.length === 2) {
        this.startDate = dates[0];
        this.endDate = dates[1];
        try {
          this.loader = true;
          this.invoiceSummary.totalInvoices = 0;
          this.purchaseOrderSummary.totalPurchaseOrders = 0;
          await this.fetchTopSuppliersByPo()
          await this.fetchPurchaseOrderSummary();
          await this.fetchInvoiceSummary();
          await this.fetchTopSuppliersByInvoices();
          this.loader = false;
        } catch (error) {
          console.error('Erreur lors de la récupération des fournisseurs :', error);
        }
      }
    },
    async SecondDateRangeChange(dates) {
      if (Array.isArray(dates) && dates.length === 2) {
        this.startDatereport = dates[0];
        this.endDatereport = dates[1];
        try {
          this.loadertwo = true;
          await this.fetchPaidInvoicesAmountByCurrencyData();
          await this.fetchThresholdData();
          await this.fetchExpiredPurchaseOrdersData();
          await this.fetchExpiredInvoicesData();
          await this.fetchCompletedPurchaseOrdersbySuppliersData();
          this.loadertwo = false;
        } catch (error) {
          console.error('Erreur lors de la récupération des fournisseurs :', error);
        }
      }
    },

    InvoiceViewAllClick() {
      this.invoicesList = this.$refs['invoices-list'];
      if (this.invoicesList) {
        this.invoicesList.classList.add('scrollable');
      }
    },
    PoViewAllClick() {
      this.purchaseOrderList = this.$refs['purchase-order-list'];
      if (this.purchaseOrderList) {
        this.purchaseOrderList.classList.add('scrollable');
      }
    },
    calculateMaxHeight() {
      const cardElements = document.querySelectorAll('.card-height');
      let maxHeight = 0;
      cardElements.forEach((card) => {
        const height = card.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      return maxHeight;
    },
    async fetchExpiredPurchaseOrdersData() {
      try {
        const response = await GetExpiredPurchaseOrders(this.startDatereport, this.endDatereport);
        this.totalExpiredPurchaseOrders = response.data.totalExpiredPurchaseOrders;
        this.TotalExpiringSoonPurchaseOrders = response.data.totalExpiringSoonPurchaseOrders;
        this.PoPercentageOfTotal = response.data.percentageOfTotal
        this.PoPercentageExpiringSoon = response.data.percentageExpiringSoon
        this.loadertwo = false;
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
      }
    },
    async fetchExpiredInvoicesData() {
      try {
        const response = await GetExpiredInvoices(this.startDatereport, this.endDatereport);
        this.totalExpiredInvoices = response.data.totalExpiredInvoices;
        this.totalExpiringSoonInvoices = response.data.totalExpiringSoonInvoices;
        this.InvoicePercentageOfTotal = response.data.percentageOfTotal;
        this.InvoicePercentageExpiringSoon = response.data.percentageExpiringSoon
        this.loadertwo = false;
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
      }
    },
    handleSelection(value) {
      this.SupplierSearch = value;
      this.fetchPaidInvoicesAmountByCurrencyData();
      this.fetchCompletedPurchaseOrdersbySuppliersData();
    },
    GetSupplierList() {
      GetCompanyFromPurchaseOrders()
        .then((res) => {
          this.SupplierList = res.data;
        })
    },
    async fetchPaidInvoicesAmountByCurrencyData() {
      try {

        this.loadertwo = true;
        const allPaidInvoices = await GetPaidInvoicesAmountByCurrency(this.IdSupplier, this.startDatereport, this.endDatereport);

        const ctx = this.$refs.lineChartCanvas.getContext('2d');
        if (this.paidInvoices) {
          this.paidInvoices.destroy();
        }


        const data = allPaidInvoices.data.map(invoice => {
          return {
            date: moment(invoice.created).format('MMMM'),
            amount: invoice.amountTTC,
            totalPaidInvoices: invoice.totalInvoices,
            currency: invoice.devise
          };
        });
        this.showWarningtwo = data.length === 0;
        if (!this.showWarningtwo) {
          const labels = data.map(item => item.date);
          const amounts = data.map(item => item.amount);
          const minAmount = Math.min(...amounts);
    
          this.paidInvoices = new Chart(ctx, {
            type: 'line',
            data: {
              labels: labels,
              datasets: [{
                label: 'Paid Invoice en €',
                data: amounts,
                borderColor: '#0d6efd',
                backgroundColor: 'rgba(13, 110, 253, 0.1)',
                borderWidth: 3,
                pointRadius: 4,
                pointBackgroundColor: '#0d6efd',
                fill: true,
                tension: 0.4,
              }],
            },
            options: {
              scales: {
                y: {
                  min: minAmount,
                },
              },
            },
          });
        }
      } catch (error) {
        console.error('Error fetching paid invoices data:', error);
      } finally {
        this.loadertwo = false;
      }
    },
    updateChart() {
      const canvas = document.getElementById('lineChartCanvasid');
      this.paidInvoices = new Chart(canvas.getContext('2d'), {
        type: 'line',
        data: this.lineChartData,
        options: this.lineChartOptions
      });
    },
    calculateMaxHeightChartline() {
      const chartHeight = this.$refs.lineChartCanvas ? this.$refs.lineChartCanvas.offsetHeight : 0;
      const warningHeight = this.$refs.warningInfo ? this.$refs.warningInfo.offsetHeight : 0;
      return Math.max(chartHeight, warningHeight, 475);
    },
    async fetchThresholdData() {
      try {
        const response = await GetPurchaseOrderByThresold(this.startDatereport, this.endDatereport);
        this.itemsUnder80Percent = response.data;
        this.itemsOver80Percent = response.data;
        this.loadertwo = false;
      } catch (error) {
        console.error('Error fetching threshold data:', error);
      }
    },
    async fetchTopSuppliersByInvoices() {
      try {
        const response = await GetTopSuppliersByInvoices(this.startDate, this.endDate);
        this.topSuppliersByInvoice = response.data;
        this.progressValueInvoice = this.topSuppliersByInvoice.map(supplier => (supplier.amountTTCPercentage));
        this.showWarning = this.topSuppliersByInvoice.length === 0;
        this.loader = false;
      } catch (error) {
        console.error('Erreur lors de la récupération des fournisseurs :', error);
        this.showWarning = true;
      }
    },
    async fetchTopSuppliersByPo() {
      try {
        const response = await GetTopSuppliers(this.startDate, this.endDate);
        this.topSuppliers = response.data;
        this.progressValueSupplier = this.topSuppliers.map(supplier => (supplier.consumptionPercentage));
        this.showWarning = this.topSuppliers.length === 0;
        this.loader = false;
      } catch (error) {
        console.error('Erreur lors de la récupération des fournisseurs :', error);
        this.loader = false;
        this.showWarning = true;
      }
    },

    async fetchInvoiceSummary() {
      try {
        const response = await GetInvoiceSummary(this.startDate, this.endDate);
        this.invoiceSummary = {
          totalInvoices: response.data.totalInvoices,
          paidInvoices: response.data.paidInvoices,
          sentInvoices: response.data.sentInvoices,
          rejectedInvoices: response.data.rejectedInvoices,
          validatedInvoices: response.data.validatedInvoices,
        };
        this.loader = false;
        this.showWarning = this.invoiceSummary.length === 0;
        this.$nextTick(() => {
          this.updateInvoicePieChart();
        });
      } catch (error) {
        console.error('Erreur lors de la récupération des données :', error);
        this.showWarning = true;
      }
    },
    async fetchPurchaseOrderSummary() {
      try {
        const response = await GetPurchaseOrderSummary(this.startDate, this.endDate);
        this.purchaseOrderSummary = {
          totalPurchaseOrders: response.data.totalPurchaseOrders,
          validatedByClient: response.data.validatedByClient,
          validatedBySupplier: response.data.validatedBySupplier,
          refusedBySupplier: response.data.refusedBySupplier,
          completed: response.data.completed,
        };
        this.$nextTick(() => {
          this.updatePieChartPurchaseOrder();
        });
        this.loader = false;
        this.showWarning = this.purchaseOrderSummary.length === 0;
      } catch (error) {
        console.error('Erreur lors de la récupération des données des commandes d\'achat :', error);
        this.showWarning = true;
      }
    },
    async updateInvoicePieChart() {
      if (this.invoiceSummary) {
        this.invoicesdataEntries = [
          { label: 'Paid', count: this.invoiceSummary.paidInvoices.count, percentage: this.invoiceSummary.paidInvoices.percentage },
          { label: 'Submitted', count: this.invoiceSummary.sentInvoices.count, percentage: this.invoiceSummary.sentInvoices.percentage },
          { label: 'Refused', count: this.invoiceSummary.rejectedInvoices.count, percentage: this.invoiceSummary.rejectedInvoices.percentage },
          { label: 'Validated', count: this.invoiceSummary.validatedInvoices.count, percentage: this.invoiceSummary.validatedInvoices.percentage },
        ];

        const filteredEntries = this.invoicesdataEntries.filter(entry => entry.count !== null && entry.count !== 0);
        const filteredLabels = filteredEntries.map(entry => entry.label);
        const filteredData = filteredEntries.map(entry => entry.count);
        const filteredPercentages = filteredEntries.map(entry => entry.percentage);

        if (this.invoiceChart) {
          this.invoiceChart.destroy();
        }
        this.invoiceChart = new Chart(document.getElementById('pie-chart-invoice').getContext('2d'), {
          type: 'pie',
          data: {
            labels: filteredLabels,
            datasets: [{
              data: filteredData,
              backgroundColor: [
                '#16BFD6',
                '#1452FF',
                '#1914FF',
                '#6646E5'
              ],
              percentage: filteredPercentages,
            }],
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
              tooltip: {
                enabled: true,
              },
              datalabels: {
                color: '#fff',
                font: {
                  weight: 'bold',
                },
                formatter: (value, ctx) => {
                  const dataset = ctx.chart.data.datasets[0];
                  const percentage = dataset.percentage[ctx.dataIndex];
                  if (value === null) {
                    return value;
                  } else {
                    return `${percentage.toFixed(0)}%`;
                  }
                },
              },
              legend: {
                display: true,
                position: 'right',
              },
            },
            hover: {
              mode: 'nearest',
              intersect: true,
            },
            tooltips: {
              enabled: true,
              callbacks: {
                label: (tooltipItem, data) => {
                  const dataset = data.datasets[tooltipItem.datasetIndex];
                  const count = dataset.data[tooltipItem.index];
                  const percentage = dataset.percentage[tooltipItem.index];
                  return `${count} (${percentage.toFixed(2)}%)`;
                }
              },
            },
          },
          plugins: [ChartDataLabels],
        });
      }
    },
    async updatePieChartPurchaseOrder() {
      if (this.purchaseOrderChart) {
        this.purchaseOrderChart.destroy();
      }
      if (this.purchaseOrderSummary) {
        const POdataEntries = [
          { label: 'Initialized', count: this.purchaseOrderSummary.validatedByClient.count, percentage: this.purchaseOrderSummary.validatedByClient.percentage },
          { label: 'Active', count: this.purchaseOrderSummary.validatedBySupplier.count, percentage: this.purchaseOrderSummary.validatedBySupplier.percentage },
          { label: 'Refused', count: this.purchaseOrderSummary.refusedBySupplier.count, percentage: this.purchaseOrderSummary.refusedBySupplier.percentage },
          { label: 'Completed', count: this.purchaseOrderSummary.completed.count, percentage: this.purchaseOrderSummary.completed.percentage },
        ];
        const filteredEntries = POdataEntries.filter(entry => entry.count !== null && entry.count !== 0);
        const filteredLabels = filteredEntries.map(entry => entry.label);
        const filteredData = filteredEntries.map(entry => entry.count);
        const filteredPercentages = filteredEntries.map(entry => entry.percentage);
        this.purchaseOrderChart = new Chart(document.getElementById('doughnut-chart-purchase-order').getContext('2d'), {
          type: 'doughnut',
          data: {
            labels: filteredLabels,
            datasets: [{
              data: filteredData,
              backgroundColor: [
                '#3114E2',
                '#16BFD6',
                '#005ECD',
                '#165BAA'
              ],
              percentage: filteredPercentages,
            }],
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
              tooltip: {
                enabled: true,
              },
              datalabels: {
                color: '#fff',
                font: {
                  weight: 'bold',
                },
                formatter: (value, ctx) => {
                  const dataset = ctx.chart.data.datasets[0];
                  const percentage = dataset.percentage[ctx.dataIndex];
                  if (value === null) {
                    return value;
                  } else {
                    return `${percentage.toFixed(0)}%`;
                  }
                },
              },
              legend: {
                display: true,
                position: 'right',
              },
            },
            hover: {
              mode: 'nearest',
              intersect: true,
            },
          },
          plugins: [ChartDataLabels],
        });
      }
    },

    async fetchCompletedPurchaseOrdersbySuppliersData() {
      try {
        const response = await GetCompletedPurchaseOrdersbySuppliers(this.IdSupplier, this.startDatereport, this.endDatereport);
        this.CompletedPurchaseOrders = response.data;

        const ctx = document.getElementById('vertical-bar-chart').getContext('2d');
        if (this.CompletedPurchaseOrdersChart) {
          this.CompletedPurchaseOrdersChart.destroy();
        }
        const filteredPurchaseOrders = this.CompletedPurchaseOrders.filter(po => po.amountTotal - po.consumption > 0);
        const labels = filteredPurchaseOrders.map(po => po.title);
        const poAmountData = filteredPurchaseOrders.map(po => po.amountTotal);
        const consumptionData = filteredPurchaseOrders.map(po => po.consumption);
        this.CompletedPurchaseOrdersChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Paid',
              data: consumptionData,
              backgroundColor: '#1D4ED8',
            }, {
              label: 'PO Amount',
              data: poAmountData,
              backgroundColor: '#0d6efd63',
            }],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                stacked: true,
                grid: {
                  display: true,
                  color: 'rgba(0,0,0,0.1)',
                },
                ticks: {
                  fontColor: '#333',
                },
              },
              y: {
                stacked: true,
                grid: {
                  display: true,
                  color: 'rgba(0,0,0,0.1)',
                },
                ticks: {
                  fontColor: '#333',
                },
              },
            },
            plugins: {
              legend: {
                display: true,
                labels: {
                  fontColor: '#333',
                },
              },
              title: {
                display: true,
                text: 'Paid purchase Orders',
                fontColor: '#333',
              },
            },
          },
        });

      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
      }
    },
  }
}
</script>

<style>
.currency-symbol {
  position: absolute;
  left: -10px;
  top: 0;
  font-size: 12px;
}

.chart-container {
  width: 100%;
  height: 300px;
  max-width: 100%;
  margin: 0 auto;
  margin-top: -50px !important;
}

.font-weight {
  color: #89CFF0;
}

.title-lg {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.title-margin {
  font-size: 16px !important;
  font-weight: bold !important;
}

.title-md {
  font-size: 12px !important;
  color: #18181B !important;
}

.warning-height {
  height: 400px;
}

.card-height {
  height: 105% !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
}

.subtitle-text {
  font-size: 20px;
  color: #0CAFFF;
  font-weight: bold;
}

.percentage-button {
  margin: 5px;
  border-radius: 10px;
  background-color: rgba(32, 201, 151, 0.2);
}

.percentage-button-down {
  margin: 5px;
  border-radius: 10px;
  background-color: rgba(220, 53, 69, 0.16);
}

.divider {
  border-style: solid;
  border-width: 1px;
  position: relative;
  top: -10px;
}

.progress-container {
  margin: 0 10px;
}

.custom-margin {
  margin-top: 9px;
}

.green-text {
  color: #064E3B;
  background-color: #ECFDF5;
}

.orange-text {
  color: #ffa500;
  background-color: #FEF2F2;
}

.red-text {
  color: #B91C1C;
  background-color: #FEF2F2;
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 116px;
}

.content-container {
  height: 200px;
}

.total-mrgine {
  font-size: medium;
  color: #0B1354;
}

.warning-text {
  margin-top: 95px !important;
}

.gray-out {
  color: gray !important;
  pointer-events: none;
}

.scrollable {
  overflow-y: auto;
  max-height: 600px;
  height: 260px;
  scrollbar-width: thin;
  scrollbar-color: #4F46E59C #add8e600;
}

.hover-effect {
  cursor: pointer;
  transition: color 0.3s, text-decoration 0.3s;
}

.textCenterWarning {
  flex-direction: column;
}
</style>